/* F&NT · Pago exprés (v36 · 2026-10-23) [Diego 23-oct]
   1) Carrito lateral con Apple Pay disponible (iPhone, iPad o Mac con Safari): si Shopify manda Apple Pay y Google Pay,
      quita Google Pay: quedan 3 botones en una fila (Shop Pay, Apple Pay, PayPal) en vez de 4 apilados.
      Android y computadora no cambian. Cómo: Shopify dibuja los botones dentro de una caja cerrada y decide fila o pila
      según cuántos son y el ancho (4 botones en menos de 430 px = pila). Se quita Google Pay de su lista (atributo
      wallet-configs) y se vuelve a montar el elemento; Shopify lo dibuja con la lista nueva. Solo en [data-fnt-express].
      Prueba sin iPhone: abre la tienda con ?fnt_prueba_sin_gpay=1 (quita Google Pay en cualquier navegador, en esa pestaña).
   2) Quien toca un botón de pago exprés (Shop Pay, Apple Pay, Google Pay o PayPal, en el carrito o en la ficha) ya va a pagar:
      no se le abre «¿Te guardamos tu carrito?» (assets/fnt-carrito-guardar.js) en esa visita, aunque cancele y cierre el carrito.
      Se marca la misma llave de sesión que ese script usa cuando el formulario ya se vio.
   Para revertir: en layout/theme.liquid quita el <script> de este archivo (va pegado al de fnt-carrito-guardar.js). */
(function () {
  'use strict';
  if (window.__fntPagoExpres) return;
  window.__fntPagoExpres = true;

  // 2) Intención de pago
  var BOTONES = 'shopify-accelerated-checkout-cart, shopify-accelerated-checkout';
  function vaAPagar() { try { sessionStorage.setItem('fntCarritoForm_visto', '1'); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(BOTONES)) vaAPagar();
  }, true);
  // PayPal vive en un iframe: el clic no llega a la página, pero el foco sí se va al iframe
  window.addEventListener('blur', function () {
    var a = document.activeElement;
    if (a && a.closest && a.closest(BOTONES)) vaAPagar();
  });

  // 1) Sin Google Pay cuando hay Apple Pay
  var prueba = false;
  try {
    if (/[?&]fnt_prueba_sin_gpay=1/.test(location.search)) sessionStorage.setItem('fnt_prueba_sin_gpay', '1');
    prueba = sessionStorage.getItem('fnt_prueba_sin_gpay') === '1';
  } catch (e) {}
  function hayApplePay() {
    try { return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (e) { return false; }
  }
  if (!prueba && !hayApplePay()) return;

  var SEL = '[data-fnt-express] shopify-accelerated-checkout-cart';
  function arreglar(el) {
    var lista;
    try { lista = JSON.parse(el.getAttribute('wallet-configs') || ''); } catch (e) { return; }
    if (!Array.isArray(lista)) return;
    var nombres = lista.map(function (w) { return w && w.name; });
    if (nombres.indexOf('google_pay') < 0) return;
    if (!prueba && nombres.indexOf('apple_pay') < 0) return;
    var nuevo = el.cloneNode(false);
    nuevo.setAttribute('wallet-configs', JSON.stringify(lista.filter(function (w) { return w && w.name !== 'google_pay'; })));
    el.replaceWith(nuevo);
  }
  function revisar() { document.querySelectorAll(SEL).forEach(arreglar); }

  revisar();
  new MutationObserver(function (cambios) {
    for (var i = 0; i < cambios.length; i++) {
      if (cambios[i].type === 'attributes' || cambios[i].addedNodes.length) { revisar(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['wallet-configs'] });
})();
